import React, {useContext} from 'react'
import Geometry from 'ol/geom/Geometry'
import AppContext from '../../appContext'
import LandResponse from '../../controllers/LandResponse'
import CheckBox from '../../components/CheckBox'
import {boundaryAreaHectares} from '../../controllers/boundaryGeo'

interface LimeBlocksTabProps {
    sampleCounts: Map<number, number>
    unmatchedCount: number
    selectedLandIds: number[]
    onSelectedChange: (selectedLandIds: number[]) => void
    farmLands: LandResponse[]
    geometryMap: Record<number, Geometry>
    showUnmatched: boolean
    onShowUnmatchedChange: (value: boolean) => void
}

const LimeBlocksTab: React.FC<LimeBlocksTabProps> = ({sampleCounts, unmatchedCount, selectedLandIds, onSelectedChange, farmLands, geometryMap, showUnmatched, onShowUnmatchedChange}) => {
    const context = useContext(AppContext)

    function toggleBlock(landId: number) {
        if (selectedLandIds.includes(landId)) {
            onSelectedChange(selectedLandIds.filter(id => id !== landId))
        } else {
            onSelectedChange([...selectedLandIds, landId])
        }
    }

    return (
        <div className="p-4">
            <table className="w-full text-sm">
                <thead>
                    <tr className="border-b text-left text-gray-600">
                        <th className="p-2 w-10"></th>
                        <th className="p-2">{context.word('block_name')}</th>
                        <th className="p-2 text-right">{context.word('area')} (ha)</th>
                        <th className="p-2 text-right">{context.word('samples')}</th>
                    </tr>
                </thead>
                <tbody>
                    {unmatchedCount > 0 && (
                        <tr
                            className={`border-b cursor-pointer hover:bg-gray-50 ${showUnmatched ? '' : 'opacity-50'}`}
                            onClick={() => onShowUnmatchedChange(!showUnmatched)}
                        >
                            <td className="p-2">
                                <CheckBox value={showUnmatched} onChange={() => onShowUnmatchedChange(!showUnmatched)}/>
                            </td>
                            <td className="p-2 italic text-gray-500">{context.word('unmatched')}</td>
                            <td className="p-2"></td>
                            <td className="p-2 text-right">{unmatchedCount}</td>
                        </tr>
                    )}
                    {farmLands.map(land => {
                        // Geodesic area across every part of the (possibly multipart) boundary.
                        const area = boundaryAreaHectares(geometryMap[land.id] ?? null)
                        const isSelected = selectedLandIds.includes(land.id)
                        const sampleCount = sampleCounts.get(land.id) ?? 0
                        return (
                            <tr
                                key={land.id}
                                className={`border-b cursor-pointer hover:bg-gray-50 ${isSelected ? '' : 'opacity-50'}`}
                                onClick={() => toggleBlock(land.id)}
                            >
                                <td className="p-2">
                                    <CheckBox value={isSelected} onChange={() => toggleBlock(land.id)}/>
                                </td>
                                <td className="p-2 font-medium">{land.name}</td>
                                <td className="p-2 text-right">{area !== null ? area.toFixed(2) : '—'}</td>
                                <td className="p-2 text-right">{sampleCount}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default LimeBlocksTab
